var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "yxtbiz-ote-num-input", on: { click: _vm.focus } },
    [
      _c("span", [_vm._v(_vm._s(_vm.name))]),
      _c(
        "span",
        { staticClass: "flex" },
        [
          _c("yxt-input", {
            ref: "inputer",
            attrs: { size: "small", maxlength: (_vm.max + "").length },
            on: { change: _vm.changeInput },
            model: {
              value: _vm.text,
              callback: function ($$v) {
                _vm.text = $$v
              },
              expression: "text",
            },
          }),
        ],
        1
      ),
      _c("span", { staticClass: "flex flex-vertical" }, [
        _c(
          "button",
          {
            on: {
              click: function ($event) {
                $event.stopPropagation()
                return _vm.changeInput(_vm.value + 1)
              },
            },
          },
          [
            _c(
              "yxt-tooltip",
              {
                attrs: {
                  disabled: !_vm.maxTip || _vm.value < _vm.max,
                  content: _vm.maxTip,
                  placement: "top",
                },
              },
              [
                _c("yxt-svg", {
                  staticClass: "trans-270deg",
                  class:
                    _vm.value >= _vm.max
                      ? "not-allowed color-gray-4"
                      : "hover-primary-6 hand",
                  attrs: {
                    width: "12px",
                    height: "12px",
                    "icon-class": "right",
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "button",
          {
            on: {
              click: function ($event) {
                $event.stopPropagation()
                return _vm.changeInput(_vm.value - 1)
              },
            },
          },
          [
            _c("yxt-svg", {
              staticClass: "trans-90deg",
              class:
                _vm.value <= _vm.min
                  ? "not-allowed color-gray-4"
                  : "hover-primary-6 hand",
              attrs: { width: "12px", height: "12px", "icon-class": "right" },
            }),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }